/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
// @ts-ignore
import { CKEditor } from '@ckeditor/ckeditor5-react';
// @ts-ignore
import CustomBuild from 'ckeditor5-custom-build';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useCommentaries } from '../../hooks/commentaries/useCommentaries';
import { ICommentariesLayout } from '../../types/layout/commentaries';
import Loader from '../loader';
import CommentariesList from './list';
import expandIcon from '../../assets/icons/expand-solid.svg';

export interface ICommentariesProps {
    rowId?: string | number;
}

function Commentaries(props: ICommentariesLayout & ICommentariesProps) {
    const { editable, disabled, maxHeight } = props;
    const [fullscreen, setFullscreen] = useState(false);

    const {
        list, loading, value, setValue, onSend, sendLoading, uploadFile,
    } = useCommentaries(props);

    const { getRootProps } = useDropzone({
        disabled,
        onDrop: uploadFile,
        noClick: true,
    });

    const onChangeHandler = (_: any, editor: any) => {
        setValue(editor.getData());
    };

    const onFullscreenClick = (e: any) => {
        e.preventDefault();
        setFullscreen((prev) => !prev);
    };

    const disableDragAndDropFn = (evt: any, data: any) => {
        evt.stop();
        data.preventDefault();
    };

    const onReady = (editor: any) => {
        if (editor?.ui?.view?.toolbar?.element?.firstChild) {
            const { firstChild } = editor.ui.view.toolbar.element;
            const btn = document.createElement('button');
            btn.className = 'ck ck-button ck-off';
            btn.innerHTML = `<img src="${expandIcon}" style="height: 16px; width: 16px;" />`;
            btn.onclick = onFullscreenClick;
            firstChild.append(btn);
        }
        if (typeof editor?.editing?.view?.document?.on === 'function') {
            editor.editing.view.document.on('drop', disableDragAndDropFn, { priority: 'high' });
            editor.editing.view.document.on('dragover', disableDragAndDropFn, { priority: 'high' });
        }
        if (typeof editor?.editing?.view?.change === 'function') {
            editor.editing.view.change((writer: any) => {
                writer.setStyle(
                    'height',
                    `${maxHeight}px`,
                    editor.editing.view.document.getRoot(),
                );
            });
        }
    };

    const classList = [];

    if (fullscreen) {
        classList.push('html-editor-fullscreen');
    }

    return (
        <>
            <Loader loading={loading} />
            <div className={classList.join(' ')}>
                {React.createElement('div', getRootProps(), [
                    <CKEditor
                        disabled={editable === false}
                        editor={CustomBuild}
                        data={value}
                        onChange={onChangeHandler}
                        onReady={onReady}
                    />,
                ])}
            </div>
            <div className="text-right mt-2">
                <button disabled={editable === false} className="btn btn-primary" type="button" onClick={onSend}>
                    Отправить
                    <div className="spinner-border spinner-border-sm ml-2" role="status" hidden={!sendLoading} />
                </button>
            </div>
            <CommentariesList list={list} />
        </>
    );
}

export default Commentaries;
